<template>
  <div class="container">
    <iframe
      class="fileBox"
      :src="'https://view.officeapps.live.com/op/view.aspx?src=' + url"
      width="100%"
      height="100%"
    >
    </iframe>
    <iframe class="fileBox" :src="url" width="100%" height="100%"> </iframe>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data() {
    return {
      url: ''
    }
  },
  created() {
    console.log(decodeURIComponent(this.$route.query.url))
    this.url = decodeURIComponent(this.$route.query.url)
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';

.container {
  height: 100vh;
  width: 100vh;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  .fileBox {
    width: 100vh;
    display: flex;
    flex: 1;
  }
  img {
    width: 240px;
    height: 240px;
    margin-top: 240px;
  }

  h2 {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    line-height: 56px;
    margin-top: 20px;
  }
}
</style>
